import React from 'react';
import { useTranslation } from 'react-i18next';
import { tArray } from 'cityads-v3/i18n/utils';

import Article, { ArticleImage, ArticleSectionHeader } from 'cityads-v3/components/Article';

export default function AdvertiserMore(props) {
  const { t } = useTranslation(['AdvertiserMore']);

  return (
    <Article
      title           = {t('title')}
      pageTitle       = {t('pageTitle')}
      pageDescription = {t('pageDescription')}
      pageKeywords    = {t('pageKeywords')}
      {...props}
    >
      {tArray(t, 'p1', 'p')}

      <ArticleImage
        src={require('./img1.png')}
        caption={t('imageCaption')}
      />

      <ArticleSectionHeader>
        {t('sectionHeader')}
      </ArticleSectionHeader>

      {tArray(t, 'p2', 'p')}

      <ul>
        {tArray(t, 'list1', 'li')}
      </ul>

      <p>
        {t('p3')}
      </p>
    </Article>
  );
}
